import * as React from 'react';
import {
  FormLabel,
  FormLabelProps,
  TextField as MuiTextField,
  TextFieldProps as MuiTextFieldProps,
  styled,
} from '@mui/material';
import { Stack } from '@mui/system';

type TextFieldProps = MuiTextFieldProps & {
  id: string;
};

const StyledLabel = styled(FormLabel)<FormLabelProps>(({ theme }) => ({
  color: theme.palette.grey[800],
}));

export const TextField = ({
  variant = 'outlined',
  label,
  children,
  id,
  ...props
}: TextFieldProps) => {
  const labelId = `${id}-label`;

  return (
    <Stack spacing={1}>
      {label && <StyledLabel id={labelId}>{label}</StyledLabel>}
      <MuiTextField
        variant={variant}
        {...props}
        label={undefined}
        slotProps={{
          ...props.slotProps,
          htmlInput: {
            ...props.slotProps?.htmlInput,
            ...(label ? { 'aria-labelledby': labelId } : undefined),
          },
        }}
      >
        {children}
      </MuiTextField>
    </Stack>
  );
};
